<template>
    <div style="display:flex;flex-direction:column;height: calc(100vh - 220px);">
        <div style="display:flex;justify-content:space-between;align-items:center;padding:12px 16px;background:#f8f8f9;border:1px solid #dcdee2;border-bottom:none;">
          <div>
            <Poptip
              confirm
              title="确定要批量删除吗？"
              transfer
              @on-ok="handleBatchDelete"
            >
              <Button type="error" :disabled="selectedIds.length === 0">批量删除</Button>
            </Poptip>
          </div>
          <div style="color:#999;font-size:13px;">共 {{ page.total }} 部</div>
        </div>
        <div ref="scrollContainer" class="scroll-wrapper" style="flex:1;overflow-y:auto;border:1px solid #dcdee2;">
            <Table
              ref="tableDragRef"
              :data="tableData"
              :columns="columns.filter(i=>!i.hide)"
              :loading="loading"
              row-key="playId"
              @on-select="handleTableSelect"
              @on-select-cancel="handleTableSelectCancel"
              @on-select-all="handleTableSelectAll"
              @on-select-all-cancel="handleTableSelectAllCancel"
            >
            <template #sortIndex="{ row }">
                <div class="sort-index-cell" :data-play-id="row.playId" style="display:flex;align-items:center;justify-content:center;">
                    <Icon v-if="!isReservationStyle" type="md-menu" class="drag-handle" style="font-size:16px;color:#bbb;cursor:move;margin-right:6px;"></Icon>
                    <span style="font-weight:600;">{{ tableData.findIndex(r => r.playId === row.playId) + 1 }}</span>
                </div>
            </template>
            <template #rankIndex="{ row }">
              <div class="sort-index-cell" :data-play-id="row.playId" style="display:flex;align-items:center;justify-content:center;">
                <Icon type="md-menu" class="drag-handle" style="font-size:16px;color:#bbb;cursor:move;margin-right:6px;"></Icon>
                <span style="font-weight:600;">{{ tableData.findIndex(r => r.playId === row.playId) + 1 }}</span>
              </div>
            </template>
            <template #playInfo="{row}">
              <div style="display:flex;align-items:center;gap:14px;">
                <div style="flex-shrink:0;width:84px;height:112px;border-radius:4px;overflow:hidden;background:#f0f0f0;">
                  <img
                    v-if="row.fileUrl"
                    :src="row.fileUrl"
                    style="width:100%;height:100%;object-fit:cover;cursor:pointer;"
                    @click="$viewerApi({images:[row.fileUrl]})"
                  />
                </div>
                <div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:6px;">
                  <div style="font-size:14px;font-weight:600;color:#1c2438;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                    {{ row.playName || '-' }}
                  </div>
                  <div style="font-size:12px;color:#808695;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                    {{ row.chinesePlayName || '-' }}
                  </div>
                </div>
              </div>
            </template>
            <template #tagNames="{row}">
              <div style="display:flex;flex-wrap:wrap;gap:4px;align-items:center;">
                <Tag
                  v-for="(tag, idx) in (row.tagNames || []).slice(0,3)"
                  :key="idx"
                  color="blue"
                  style="font-size:12px;height:22px;line-height:20px;padding:0 8px;"
                >{{ tag }}</Tag>
                <Poptip
                  v-if="(row.tagNames || []).length > 3"
                  trigger="hover"
                  transfer
                  placement="top"
                >
                  <Tag color="default" style="font-size:12px;height:22px;line-height:20px;padding:0 8px;">+{{ (row.tagNames || []).length - 3 }}</Tag>
                  <template #content>
                    <div style="max-width:240px;">
                      <div v-for="(tag, idx) in row.tagNames" :key="idx" style="margin:4px 0;">
                        {{ tag }}
                      </div>
                    </div>
                  </template>
                </Poptip>
              </div>
            </template>
            <template #publishDate="{row}">
              <div :style="Number(row.playRelease) === 3 ? 'color:#ed4014;' : 'color:#515a6e;'">
                <div>{{ Number(row.playRelease) === 2 ? '待发布' : Number(row.playRelease) === 0 ? '未发布' : (row.playReleaseName || '-') }}</div>
                <div v-if="row.releaseDate" style="margin-top:2px;font-size:12px;color:#999;">{{ row.releaseDate }}</div>
              </div>
            </template>
            <template #isTop="{row}">
              <i-switch
                :value="!!row.sticky"
                @on-change="(val) => handleStickyChange(row, val)"
              ></i-switch>
            </template>
            <template #action="{row}">
                <a
                  style="color: #808695;"
                  :style="(isReservationStyle || tableData.findIndex(r => r.playId === row.playId) === 0) ? 'pointer-events:none;color:#c5c8ce;cursor:not-allowed;' : 'cursor:pointer;color:#2d8cf0;'"
                  @click="handleTop(row)"
                >置顶</a>
                <Poptip confirm title="确定要删除吗？" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>
            </template>
            </Table>
        </div>
        <div style="display:flex;justify-content:flex-end;align-items:center;padding:12px 16px;border:1px solid #dcdee2;border-top:none;background:#fff;">
            <Button @click="handleCancel" style="margin-right:12px;">取消</Button>
            <Button type="primary" :loading="saveLoading" @click="handleSaveChange">保存更改</Button>
        </div>
        <Modal
          ref="addModalRef"
          v-model="visible"
          title="添加短剧"
          :width="1000"
          :mask-closable="false"
          :before-close="() => handleBeforeClose()"
        >
            <MovieAdd
              v-if="visible"
              ref="addRef"
              :func="getTheaterPlayPageByCondition"
              :form="form"
              :query="{ theaterId: form.id, langId: form.langId }"
              :show-lang="false"
              :selectedData="tableData.map(i=>i.playId)||[]"
              @update:selectedCount="val => selectedCount = val"
            ></MovieAdd>
            <template #footer>
                <div style="display:flex;align-items:center;justify-content:space-between;width:100%;">
                    <div style="font-size:13px;color:#808695;">
                      已选 {{ selectedCount }} 部
                    </div>
                    <div>
                      <Button @click="handleCancelAddModal" style="margin-right:12px;">取消</Button>
                      <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import MovieAdd from './movie-add.vue'
import Sortable from 'sortablejs'
import uuidv4 from 'uuid/v4'
import { getTheaterPlay, addTheaterPlay, delTheaterPlay, getTheaterPlayPageByCondition, editTheaterPlaySort, changeSticky } from '@/api/theater'

export default {
  components: { MovieAdd },
  props:{
    form:{
      type: Object,
      default:() => ({})
    }
  },
  data() {
    return {
      loading: false,
      page:{
        current: 1,
        size: -1,
        total: 0
      },
      submitLoading: false,
      saveLoading: false,
      getTheaterPlayPageByCondition,
      tableData: [],
      originalTableData: [],
      pendingDelete: [],
      pendingAdd: [],
      selectedIds: [],
      selectedCount: 0,
      checkAll: false,
      indeterminate: false,
      visible:false
    }
  },
  computed: {
    hasUnsavedChanges() {
      if (this.pendingDelete && this.pendingDelete.length > 0) return true
      if (this.pendingAdd && this.pendingAdd.length > 0) return true
      const oriLen = this.originalTableData && this.originalTableData.length
      const curLen = this.tableData && this.tableData.length
      if (oriLen !== curLen) return true
      for (let i = 0; i < curLen; i++) {
        const ori = this.originalTableData[i]
        const cur = this.tableData[i]
        if (!ori || !cur) return true
        if (ori.playId !== cur.playId) return true
      }
      return false
    },
    isTop100Style() {
      return Number(this.form.theaterStyle) === 8
    },
    isStyleSix() {
      return Number(this.form.theaterStyle) === 5
    },
    isSearchPageStyle() {
      return Number(this.form.theaterStyle) === 13
    },
    isReservationStyle() {
      return Number(this.form.theaterStyle) === 20
    },
    columns() {
      if (this.isTop100Style) {
        return [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '排名',
            width: 80,
            slot: 'rankIndex',
            align: 'center'
          },
          {
            title: '短剧ID',
            key: 'playId',
            width: 100
          },
          {
            title: '短剧信息',
            slot: 'playInfo',
            minWidth: 300
          },
          {
            title: '标签',
            slot: 'tagNames',
            minWidth: 180
          },
          {
            title: '发布日期',
            slot: 'publishDate',
            minWidth: 130,
            width: 150
          },
          {
            title: '操作',
            slot: 'action'
          }
        ]
      }
      const cols = [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '当前顺序',
          width: 100,
          slot: 'sortIndex',
          align: 'center'
        },
        {
          title: '短剧id',
          key: 'playId',
          width: 100
        },
        {
          title: '短剧信息',
          slot: 'playInfo',
          minWidth: 300
        },
        {
          hide: Number(this.form.theaterStyle) !== 20,
          title: '播出时间',
          key: 'releaseDate'
        },
        {
          title: '标签',
          slot: 'tagNames',
          minWidth: 180
        },
        {
          title: '发布日期',
          slot: 'publishDate',
          minWidth: 130,
          width: 150
        }
      ]
      if (this.isStyleSix) {
        cols.push({
          title: '是否置顶',
          width: 90,
          slot: 'isTop',
          align: 'center'
        })
      }
      cols.push({
        title: '操作',
        slot: 'action'
      })
      return cols
    }
  },
  methods:{
    getPublishDateText(row) {
      const release = Number(row.playRelease)
      if (release === 1) {
        return row.releaseDate || '-'
      }
      if (release === 0) {
        return row.releaseDate ? '待发布' : '未发布'
      }
      if (release === 3) {
        return row.offlineTime || '-'
      }
      return '-'
    },
    getData() {
      this.loading = true
      getTheaterPlay({
        ...this.page,
        theaterId: this.form.id
      }).then(({ data }) => {
        this.page.total = data.total
        this.tableData = data.records.map(i => ({ ...i }))
        this.originalTableData = data.records.map(i => ({ ...i }))
        this.pendingDelete = []
        this.pendingAdd = []
        this.loading = false
        this.selectedIds = []
        this.updateCheckStatus()
      })
    },
    handleTableSelect(selection, row) {
      if (!this.selectedIds.includes(row.playId)) {
        this.selectedIds.push(row.playId)
      }
      this.updateCheckStatus()
    },
    handleTableSelectCancel(selection, row) {
      this.selectedIds = this.selectedIds.filter(id => id !== row.playId)
      this.updateCheckStatus()
    },
    handleTableSelectAll(selection) {
      this.selectedIds = (selection || []).map(i => i.playId)
      this.updateCheckStatus()
    },
    handleTableSelectAllCancel() {
      this.selectedIds = []
      this.updateCheckStatus()
    },
    updateCheckStatus() {
      const total = this.tableData.length
      const selected = this.selectedIds.length
      this.checkAll = selected > 0 && selected === total
      this.indeterminate = selected > 0 && selected < total
    },
    handleDel(row) {
      const idx = this.tableData.findIndex(r => r.playId === row.playId)
      if (idx < 0) return
      const arr = [...this.tableData]
      const [removed] = arr.splice(idx, 1)
      this.tableData = arr
      const pendingAddIdx = this.pendingAdd.indexOf(removed.playId)
      if (pendingAddIdx >= 0) {
        this.pendingAdd.splice(pendingAddIdx, 1)
      } else if (removed.id) {
        this.pendingDelete.push({
          playIds: [removed.playId],
          theaterId: this.form.id
        })
      }
      this.page.total = this.tableData.length
      this.selectedIds = this.selectedIds.filter(id => id !== row.playId)
      this.updateCheckStatus()
    },
    handleBatchDelete() {
      if (this.selectedIds.length === 0) return
      const removeSet = new Set(this.selectedIds)
      const removedItems = this.tableData.filter(r => removeSet.has(r.playId))
      this.tableData = this.tableData.filter(r => !removeSet.has(r.playId))
      const removedPendingAdd = []
      const removedNeedDelete = []
      removedItems.forEach(item => {
        if (this.pendingAdd.includes(item.playId)) {
          removedPendingAdd.push(item.playId)
        } else if (item.id) {
          removedNeedDelete.push(item.playId)
        }
      })
      if (removedPendingAdd.length > 0) {
        this.pendingAdd = this.pendingAdd.filter(pid => !removedPendingAdd.includes(pid))
      }
      if (removedNeedDelete.length > 0) {
        this.pendingDelete.push({
          playIds: removedNeedDelete,
          theaterId: this.form.id
        })
      }
      this.selectedIds = []
      this.page.total = this.tableData.length
      this.updateCheckStatus()
    },
    handleTop(row) {
      if (this.isReservationStyle) return
      const idx = this.tableData.findIndex(r => r.playId === row.playId)
      if (idx <= 0) return
      const arr = [...this.tableData]
      const [target] = arr.splice(idx, 1)
      arr.unshift(target)
      this.tableData = arr
    },
    handleStickyChange(row, val) {
      const idx = this.tableData.findIndex(r => r.playId === row.playId)
      if (idx < 0) return
      this.tableData[idx].sticky = val
    },
    restoreSelectionCheck() {
      const table = this.$refs.tableDragRef
      if (!table || !table.objData) return
      const selectedIdSet = {}
      ;(this.selectedIds || []).forEach(id => {
        selectedIdSet[String(id)] = true
      })
      ;(this.tableData || []).forEach((row, index) => {
        const objRow = table.objData[index]
        if (objRow && selectedIdSet[String(row.playId)]) {
          objRow._isChecked = true
        }
      })
    },
    handleOpen() {
      this.visible = true
    },
    handleBeforeClose() {
      if (this.selectedCount > 0) {
        return new Promise(resolve => {
          this.$Modal.confirm({
            title: '取消添加',
            content: `您已选择 ${this.selectedCount} 部短剧，取消后选择将不会被保存。确定要取消吗？`,
            okText: '确定取消',
            cancelText: '继续选择',
            type: 'warning',
            onOk: () => resolve(),
            onCancel: () => {}
          })
        })
      }
    },
    handleCancelAddModal() {
      const modal = this.$refs.addModalRef
      if (modal && typeof modal.close === 'function') {
        modal.close()
      } else {
        this.visible = false
      }
    },
    handleSubmit() {
      const selection = this.$refs.addRef.selection || []
      if (selection.length === 0) {
        this.$Message.warning('请选择要添加的短剧')
        return
      }
      const existingPlayIds = new Set(this.tableData.map(i => i.playId))
      const toAdd = selection.filter(i => !existingPlayIds.has(i.playId)).map(i => ({ ...i }))
      if (toAdd.length === 0) {
        this.$Message.info('所选短剧已在列表中')
        this.visible = false
        return
      }
      if (this.isSearchPageStyle && this.tableData.length + toAdd.length > 20) {
        this.$Message.warning('搜索页剧场最多只能添加20部短剧')
        return
      }
      if (this.isReservationStyle && this.tableData.length + toAdd.length > 10) {
        this.$Message.warning('预约剧场最多只能添加10部短剧')
        return
      }
      const addPlayIds = toAdd.map(i => i.playId)
      this.pendingAdd = this.pendingAdd.concat(addPlayIds)
      this.tableData = this.tableData.concat(toAdd)
      this.page.total = this.tableData.length
      this.$Message.success(`已暂存添加 ${toAdd.length} 部短剧，点击保存更改后生效`)
      this.submitLoading = false
      this.visible = false
    },
    initSortable() {
      if (this.isReservationStyle) return
      if (this.sortableInstance) {
        this.sortableInstance.destroy()
        this.sortableInstance = null
      }
      this.$nextTick(() => {
        const tableEl = this.$refs.tableDragRef && this.$refs.tableDragRef.$el
        if (!tableEl) return
        const tbody = tableEl.querySelector('.ivu-table-body tbody')
        if (!tbody) return
        this.sortableInstance = Sortable.create(tbody, {
          handle: '.drag-handle',
          animation: 200,
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          onEnd: () => {
            const rows = Array.from(tbody.querySelectorAll('tr'))
            const playIdMap = {}
            this.tableData.forEach(item => { playIdMap[String(item.playId)] = item })
            const reordered = []
            rows.forEach(tr => {
              const cell = tr.querySelector('.sort-index-cell')
              if (cell) {
                const pid = cell.getAttribute('data-play-id')
                if (pid && playIdMap[pid]) {
                  reordered.push(playIdMap[pid])
                  delete playIdMap[pid]
                }
              }
            })
            Object.keys(playIdMap).forEach(k => reordered.push(playIdMap[k]))
            if (reordered.length > 0) {
              this.tableData = reordered
            }
          }
        })
      })
    },
    handleCancel() {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要取消吗？当前所有未保存的更改（包括拖动的顺序、删除、新增）将丢失。',
        onOk: () => {
          this.tableData = this.originalTableData.map(i => ({ ...i }))
          this.pendingDelete = []
          this.pendingAdd = []
          this.selectedIds = []
          this.updateCheckStatus()
          this.$Message.info('已恢复到上次保存状态')
          this.$emit('cancel')
        }
      })
    },
    getSkippedReasons(skipped) {
      if (!skipped) return []
      let items = []
      if (Array.isArray(skipped)) {
        items = skipped
      } else if (typeof skipped === 'string') {
        items = [skipped]
      } else if (typeof skipped === 'object') {
        items = Array.isArray(skipped.list)
          ? skipped.list
          : Object.keys(skipped).map(key => skipped[key])
      }
      return items.map(item => {
        if (typeof item === 'string') return item
        if (!item || typeof item !== 'object') return ''
        return item.reason || item.skipReason || item.message || ''
      }).filter(Boolean)
    },
    handleSaveResult(addResponse) {
      if (!this.isReservationStyle) {
        this.$Message.success('保存成功')
        return
      }
      const payload = (addResponse && addResponse.data) || addResponse || {}
      const result = payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data)
        ? payload.data
        : payload
      const messages = []
      if (result.capacityExceeded) {
        messages.push('预约剧场最多 10 部，本次未添加')
      }
      this.getSkippedReasons(result.skipped).forEach(reason => {
        const isCapacityReason = /最多.*10.*部|已满|capacity/i.test(reason)
        if (result.capacityExceeded && isCapacityReason) return
        messages.push(reason)
      })
      const uniqueMessages = [...new Set(messages)]
      if (uniqueMessages.length === 0) {
        this.$Message.success('保存成功')
        return
      }
      this.$Message.warning({
        render: h => h('div', {}, uniqueMessages.map(message => h('div', message))),
        duration: 5
      })
    },
    handleSaveChange() {
      if (this.isSearchPageStyle && this.tableData.length > 20) {
        this.$Message.warning('搜索页剧场最多只能添加20部短剧，请删除部分短剧后再保存')
        return
      }
      if (this.isReservationStyle && this.tableData.length > 10) {
        this.$Message.warning('预约剧场最多只能添加10部短剧，请删除部分短剧后再保存')
        return
      }
      this.saveLoading = true
      const playIdOrder = this.tableData.map(i => i.playId)
      const hasAddOrDelete = (this.pendingAdd && this.pendingAdd.length > 0) || (this.pendingDelete && this.pendingDelete.length > 0)
      let orderChanged = this.tableData.length !== this.originalTableData.length
      let stickyChanged = false
      if (!orderChanged) {
        for (let i = 0; i < this.tableData.length; i++) {
          if (String(this.tableData[i].playId) !== String(this.originalTableData[i].playId)) {
            orderChanged = true
          }
          if (!!this.tableData[i].sticky !== !!this.originalTableData[i].sticky) {
            stickyChanged = true
          }
        }
      } else {
        stickyChanged = true
      }
      const playIdSet = {}
      const mergedDel = []
      this.pendingDelete.forEach(p => {
        (p.playIds || []).forEach(pid => {
          if (!playIdSet[pid]) {
            playIdSet[pid] = true
            mergedDel.push(pid)
          }
        })
      })
      const mergedAddSet = {}
      const mergedAdd = []
      this.pendingAdd.forEach(pid => {
        if (!mergedAddSet[pid]) {
          mergedAddSet[pid] = true
          mergedAdd.push(pid)
        }
      })
      const addRequest = mergedAdd.length > 0
        ? addTheaterPlay({ playIds: mergedAdd, theaterId: this.form.id })
        : Promise.resolve(null)
      const deleteRequest = mergedDel.length > 0
        ? delTheaterPlay({
          playIds: mergedDel,
          theaterId: this.form.id,
          ...(this.isReservationStyle ? { operationId: uuidv4() } : {})
        })
        : Promise.resolve(null)
      Promise.all([addRequest, deleteRequest]).then(([addResponse]) => {
        if (!orderChanged && !stickyChanged && !hasAddOrDelete) {
          return addResponse
        }
        return getTheaterPlay({
          current: 1,
          size: -1,
          theaterId: this.form.id
        }).then((res) => {
          const records = (res && res.data && res.data.records) || []
          const recordMap = {}
          records.forEach(r => { recordMap[String(r.playId)] = r })
          const originalPlayIdMap = {}
          ;(this.originalTableData || []).forEach(r => { originalPlayIdMap[String(r.playId)] = r })
          const currentPlayIdMap = {}
          this.tableData.forEach(r => { currentPlayIdMap[String(r.playId)] = r })
          const sortList = playIdOrder
            .filter(pid => recordMap[String(pid)] && recordMap[String(pid)].id)
            .map((pid, idx) => ({
              id: recordMap[String(pid)].id,
              playSort: idx + 1
            }))
          const changedSortList = sortList.filter(item => {
            const record = recordMap[String(item.id)]
            const recordPlayId = record ? String(record.playId) : ''
            const original = originalPlayIdMap[recordPlayId]
            return !original || String(original.id) !== String(item.id) || Number(original.playSort) !== Number(item.playSort)
          })
          const stickyRequests = []
          Object.keys(currentPlayIdMap).forEach(playId => {
            const curr = currentPlayIdMap[playId]
            const orig = originalPlayIdMap[playId]
            const record = recordMap[playId]
            if (!record || !record.id) return
            const currentSticky = !!curr.sticky
            const origSticky = orig ? !!orig.sticky : !!record.sticky
            if (currentSticky !== origSticky) {
              stickyRequests.push(changeSticky({
                theaterId: this.form.id,
                playId: playId,
                sticky: currentSticky
              }))
            }
          })
          const allRequests = []
          if (changedSortList.length > 0 && !this.isReservationStyle) {
            allRequests.push(editTheaterPlaySort(changedSortList))
          }
          allRequests.push(...stickyRequests)
          if (allRequests.length === 0) {
            return addResponse
          }
          return Promise.all(allRequests).then(() => addResponse)
        })
      }).then((addResponse) => {
        this.handleSaveResult(addResponse)
        this.getData()
      }).catch(() => {
        this.$Message.error('保存失败')
      }).finally(() => {
        this.saveLoading = false
      })
    }
  },
  watch: {
    tableData: {
      handler() {
        this.$nextTick(() => {
          this.restoreSelectionCheck()
          this.initSortable()
        })
      },
      deep: false
    },
    visible(val) {
      if (!val) this.selectedCount = 0
    }
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    if (this.sortableInstance) {
      this.sortableInstance.destroy()
      this.sortableInstance = null
    }
  }
}
</script>

<style lang="less" scoped>
.loading-icon {
  display: inline-block;
  animation: rotating 1s linear infinite;
}
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/deep/.sortable-ghost {
  opacity: 0.4;
  background: #f0f7ff !important;
}
/deep/.sortable-chosen {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
/deep/ .drag-handle:hover {
  color: #2d8cf0 !important;
}
</style>
